import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { FolderOpen, Folder, ChevronDown, ChevronRight, Building2, User } from "lucide-react";
import { PraticaView } from "@/pages/Documenti";

function Ramo({ titolo, items, sel, setSel, testid }) {
  const [open, setOpen] = useState(items.length > 0);
  return (
    <div className="ml-3">
      <button data-testid={testid} onClick={() => setOpen((o) => !o)} className="w-full flex items-center gap-1.5 px-2 py-1.5 rounded-lg text-sm font-semibold text-slate-700 hover:bg-slate-50">
        {open ? <ChevronDown size={14} /> : <ChevronRight size={14} />}<Folder size={14} className="text-[#FC82ED]" /> {titolo}
        <span className="ml-auto text-[10px] text-[var(--muted)]">{items.length}</span>
      </button>
      {open && items.length === 0 && <p className="pl-7 py-1 text-[11px] text-[var(--muted)]">Nessun immobile</p>}
      {open && items.map((p) => (
        <button key={p.immobile_id} data-testid={`archivio-imm-${p.immobile_id}`} onClick={() => setSel(p)}
          className={`w-full flex items-start gap-2 pl-7 pr-2 py-1.5 rounded-lg text-left text-[13px] transition-colors ${sel?.immobile_id === p.immobile_id ? "bg-[#FC82ED]/15" : "hover:bg-slate-50"}`}>
          <Building2 size={13} className="mt-0.5 shrink-0 text-slate-400" />
          <span className="min-w-0"><span className="block truncate">{p.label}</span>
            <span className="text-[10px] text-[var(--muted)]">{p.n_files} file{p.archivio ? " · archiviato" : ""}</span></span>
        </button>
      ))}
    </div>
  );
}

function Collaboratore({ c, sel, setSel }) {
  const [open, setOpen] = useState(true);
  return (
    <div className="mb-1" data-testid={`archivio-collab-${c.agent_id || "na"}`}>
      <button onClick={() => setOpen((o) => !o)} className="w-full flex items-center gap-1.5 px-2 py-2 rounded-lg text-sm font-bold hover:bg-slate-50">
        {open ? <ChevronDown size={15} /> : <ChevronRight size={15} />}<User size={15} className="text-[#FC82ED]" /> <span className="truncate">{c.agent}</span>
      </button>
      {open && <>
        <Ramo titolo="Vendita" items={c.vendita} sel={sel} setSel={setSel} testid={`archivio-vendita-${c.agent_id || "na"}`} />
        <Ramo titolo="Affitto" items={c.affitto} sel={sel} setSel={setSel} testid={`archivio-affitto-${c.agent_id || "na"}`} />
      </>}
    </div>
  );
}

export default function ArchivioDocumenti() {
  const [data, setData] = useState(null);
  const [sel, setSel] = useState(null);
  const load = () => api.get("/documenti/archivio-collaboratori").then((r) => setData(r.data.collaboratori)).catch((e) => { toast.error(apiError(e)); setData([]); });
  useEffect(() => { load(); }, []);
  return (
    <div className="fade-up" data-testid="archivio-documenti-page">
      <div className="mb-5">
        <h1 className="font-display text-2xl font-extrabold flex items-center gap-2"><FolderOpen className="text-[#FC82ED]" size={24} /> Archivio documenti</h1>
        <p className="text-sm text-[var(--muted)]">Collaboratore → Vendita / Affitto → immobile. Si aggiorna da sola quando cambiano agente o contratto.</p>
      </div>
      <div className="grid md:grid-cols-[320px_1fr] gap-4">
        <aside className="card-immo p-3 h-max md:sticky md:top-4" data-testid="archivio-tree">
          {!data ? <div className="skeleton h-40 rounded-lg" /> : data.length === 0 ? <p className="text-xs text-[var(--muted)] px-2 py-4">Nessun immobile in archivio.</p>
            : data.map((c) => <Collaboratore key={c.agent_id || "na"} c={c} sel={sel} setSel={setSel} />)}
        </aside>
        <section className="min-w-0">
          {!sel ? <div className="card-immo p-10 text-center text-[var(--muted)]"><FolderOpen size={40} className="mx-auto mb-3 text-[#FC82ED]/50" />Scegli un immobile dall'albero.</div>
            : <PraticaView immobileId={sel.immobile_id} onChanged={load} />}
        </section>
      </div>
    </div>
  );
}
